<template>
  <span>
    <a-popover title="" v-if="!isExpandedBtns" placement="bottom">
      <template #content>
        <div @mouseenter="handlerMouseenter" style="width: 450px;z-index: 1;">
          <slot name='top-content' />
          <a-space>
            <a-button
              size="small"
              type="primary"
              class="commonCopyItem"
              @click="clickCopyBtn"
              :data-clipboard-text="copyContent"
            >
              复制
            </a-button>
            <a-button v-if="isShowExportText" size="small" type="primary" @click="clickExportToTxt">
              导出文本
            </a-button>
            <a-button size="small" type="primary" @click="clickExportToExcel">
              导出Excel
            </a-button>
            <a-button v-if="isShowCSV" size="small" type="primary" @click="clickExportToCsv">
              导出CSV
            </a-button>
          </a-space>
          <a-divider />
          <a-tag v-if="desc" color='red' style="margin-bottom:3px;">{{desc}}</a-tag>
          <div v-if="exportColumnTitle" style="margin-bottom: 0.5em;">
            <a-checkbox v-model:checked="isExportColumnTitle">复制、导出文本包含表头</a-checkbox>
          </div>
          <p>
            配置导出字段
            <a-checkbox
              style="margin-left: 1em"
              v-model:checked="isCheckAllField"
              :indeterminate="indeterminate"
              @change="checkAllFieldChange"
            >
              全选
            </a-checkbox>
          </p>
          <a-checkbox-group
            v-model:value="exportConfig.checkedData"
            name="checkboxgroup"
            :options="exportConfig.data"
            @change="handleChangeExportConig"
          />
        </div>
      </template>
      <a-button ghost type="primary" :size="size">
        <slot name="btnTitle">{{btnTitle}}</slot>
      </a-button>
    </a-popover>
    <span v-if="isExpandedBtns">
      <div @mouseenter="handlerMouseenter" style="width: 450px">
        <a-space>
          <a-button
            size="small"
            type="primary"
            class="commonCopyItem"
            @click="clickCopyBtn"
            :data-clipboard-text="copyContent"
          >
            复制
          </a-button>
          <a-button size="small" type="primary" @click="clickExportToTxt">
            导出文本
          </a-button>
          <a-button size="small" type="primary" @click="clickExportToExcel">
            导出Excel
          </a-button>
        </a-space>
      </div>
    </span>
  </span>
</template>

<script>
  import { ResertCopy } from '@/utils/view_util'
  import {
    GetExportConfig,
    SaveExportConfig,
    GetCopyContent,
    // ExportToTxt,
    ExportToExcel,
    ExportCsv
  } from './export_btn_handler'

  // import Clipboard from 'clipboard'
  // console.log(Clipboard)
  export default {
    props: {
      // 基础类型检测 (`null` 意思是任何类型都可以)
      key: String,
      myConfigs: Array,
      GetExportItemList: {
        type: Function,
        default: null,
      },
      isExpandedBtns: {
        //是否把里面的按钮平铺显示出来
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'default',
      },
      btnTitle: {
        type: String,
        default: '复制导出',
      },
      isShowCSV: {
        type:Boolean,
        default:true
      },
      // 是否显示【导出文本】
      isShowExportText: {
        type: Boolean,
        default: true
      },
      exportColumnTitle: {
        type: Boolean,
        default: false
      },
      desc: {
        type:String,
        default:''
      },
      // 当数据为空时，是否显示0
      isShowZero: Boolean,
      // 为选择数据时的提示信息
      errorMsg: String,
      customGetList:{}
    },
    data() {
      return {
        exportConfig: { data: [], checkedData: [] },
        copyContent: '',
        isCheckAllField: false,
        indeterminate: true,
        isExportColumnTitle: false
      }
    },
    methods: {
      clickExportToTxt() {
        var itemList = this.GetExportItemList()
        if (!this.exportConfig.checkedData.length) return this.$message.warning('请至少选择一个字段')
        if (itemList.length == 0) return this.$message.warning(this.errorMsg || '请至少勾选一条数据')
        // ExportToTxt(itemList, this.myConfigs, this.exportConfig.checkedData, this.isShowZero, this.isExportColumnTitle)
      },
      async clickExportToExcel() {
        var itemList = this.GetExportItemList()
        if (!this.exportConfig.checkedData.length) return this.$message.warning('请至少选择一个字段')
        if (this.customGetList) {
          const { list, errMsg } = await this.customGetList()
          if (!list.length) return this.$message.warn(errMsg)
          itemList = list
        }
        else if (itemList.length == 0) return this.$message.warning(this.errorMsg || '请至少勾选一条数据')
        ExportToExcel(itemList, this.myConfigs, this.exportConfig.checkedData, this.isShowZero)
      },
      clickCopyBtn() {
        console.log(this.GetExportItemList)
        var itemList = this.GetExportItemList()
        if (!this.exportConfig.checkedData.length) return this.$message.warning('请至少选择一个字段')
        if (itemList.length == 0) return this.$message.warning(this.errorMsg || '请至少勾选一条数据')
        var content = GetCopyContent(
          itemList,
          this.myConfigs,
          this.exportConfig.checkedData,
          this.isShowZero,
          this.isExportColumnTitle
        )
        console.log('获取到的数据是' + content)
        this.copyContent = content
      },
      handleChangeExportConig() {
        console.log(JSON.stringify(this.exportConfig))
        SaveExportConfig(
          this.key,
          this.myConfigs,
          this.exportConfig.checkedData
        )
      },
      handlerMouseenter() {
        this.$emit('subItemMouseenter')
      },
      clickExportToCsv() {
        var itemList = this.GetExportItemList()
        if (itemList.length == 0) return this.$message.warning(this.errorMsg || '请至少勾选一条数据')
        console.log(JSON.stringify(itemList))
        ExportCsv(itemList, this.myConfigs, this.exportConfig.checkedData, this.isShowZero)
      },
      checkAllFieldChange(e) {
        this.exportConfig.checkedData = e.target.checked ? this.myConfigs.map(item => item.name) : [],
        this.indeterminate = false
      }
    },
    mounted() {
      ResertCopy()
      var { data, checkedData } = GetExportConfig(this.key, this.myConfigs)
      this.exportConfig.data = data
      this.exportConfig.checkedData = checkedData
    },
    watch: {
      myConfigs(arr) {
        var { data, checkedData } = GetExportConfig(this.key, arr)
        this.exportConfig.data = data
        this.exportConfig.checkedData = checkedData
      },
      'exportConfig.checkedData'(val) {
        this.indeterminate = !!val.length && val.length < this.myConfigs.length;
        this.isCheckAllField = val.length === this.myConfigs.length;
      }
    }
  }
</script>

<style>
.ant-popover {
  z-index: 1009 !important;
}
.ant-divider-horizontal{
  margin:16px 0;
}
</style>
